import GEntity from './../GEntity';

export default class Pile extends GEntity {

    isPileEmpty = () => {
        return this.getCards().length === 0;
    }

    recycleUsedPile = async () => {
        let usedPile = this.gameCtx.entitiesRepo.getUsedPile();
        let usedCards = usedPile.getCards();
        
        let newCards = [];
        let candyCards = [];
        
        usedCards.forEach(card => {
            if (card.ref.current.back === "pink-back") {
                candyCards.push(card);
            }
            else {
                newCards.push(card);
            }
        });
        
        newCards = this.shuffleCardsArr(newCards);
        candyCards = this.shuffleCardsArr(candyCards);
        
        let newPile = this.gameCtx.entitiesRepo.getNewPile();
        let candyPile = this.gameCtx.entitiesRepo.getCandyPile();
        
        await this.gameCtx.moveCards(usedPile.entityIndex, newPile.entityIndex, newCards, true, false);
        await this.gameCtx.moveCards(usedPile.entityIndex, candyPile.entityIndex, candyCards, true, false);
    }

    calcRotateDeg = (cardObj = null) => {
        let currentDeg = 0;

        if (cardObj.ref.current != null) {
            currentDeg = cardObj.ref.current.getCurrentDeg();
        }

        return -currentDeg;
    }

    getCoordsForNewCard = (cardObj) => {
        let index = this.cards.length;
        return this.getCardCoordsByIndex(cardObj, index);
    }

    getCardCoordsByIndex = (cardObj, index) => {
        let rotDeg = this.calcRotateDeg(cardObj, index);

        return [this.firstCardCoords[0], this.firstCardCoords[1], rotDeg, this.cardSideShown, index + 1];
    }

    reArrangeCards = () => {
        // Overrides GEntity reArrangeCards
    }
    reArrangePile= async () => {
        this.cards.forEach((card, i) => {
            let [left, top, rotDeg, cardSideShown, layer] = this.getCardCoordsByIndex(card, i);
            card.ref.current.changePos(left, top, rotDeg, this.cardSideShown, false, 0.1, layer);
        });
    }

    

    removeCard = () => {
        return this.cards.pop();
    }
}
